<div class="container">
  <section class="customer-info"><oa-customer-information [readOnly]="isInternal"></oa-customer-information></section>
  <section class="locksmith-id"><oa-locksmith-id-numbers [readOnly]="isInternal"></oa-locksmith-id-numbers></section>
  <section class="terms-and-conditions">
    <oa-terms-and-conditions [readOnly]="isInternal"></oa-terms-and-conditions>
  </section>
</div>
